/**
 * Modal Component JavaScript
 * Handles open/close functionality, keyboard navigation, and focus trapping
 */

(function() {
  let activeModal = null;
  let previousActiveElement = null;

  /**
   * Open a modal by ID
   */
  function openModal(modalId) {
    const overlay = document.querySelector(`[data-modal-overlay][data-modal-id="${modalId}"]`);
    if (!overlay) return;

    // Store the previously focused element
    previousActiveElement = document.activeElement;

    // Show the modal
    overlay.setAttribute('aria-hidden', 'false');
    activeModal = overlay;

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Focus the first focusable element in the modal
    setTimeout(() => {
      const modal = overlay.querySelector('[data-modal]');
      const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable.length) {
        focusable[0].focus();
      }
    }, 100);

    // Dispatch custom event
    overlay.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
  }

  /**
   * Close the currently active modal or a specific modal by ID
   */
  function closeModal(modalId) {
    let overlay;
    
    if (modalId) {
      overlay = document.querySelector(`[data-modal-overlay][data-modal-id="${modalId}"]`);
    } else if (activeModal) {
      overlay = activeModal;
    }
    
    if (!overlay) return;

    // Hide the modal
    overlay.setAttribute('aria-hidden', 'true');
    
    // Restore body scroll
    document.body.style.overflow = '';

    // Restore focus to the previously focused element
    if (previousActiveElement) {
      previousActiveElement.focus();
      previousActiveElement = null;
    }

    activeModal = null;

    // Dispatch custom event
    overlay.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));
  }

  /**
   * Initialize modal triggers and close buttons
   */
  function initModals() {
    // Handle modal triggers (buttons with data-modal-open)
    document.querySelectorAll('[data-modal-open]').forEach(trigger => {
      if (trigger._modalInitialized) return;
      trigger._modalInitialized = true;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-open');
        openModal(modalId);
      });
    });

    // Handle close buttons
    document.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
      if (closeBtn._modalCloseInitialized) return;
      closeBtn._modalCloseInitialized = true;

      closeBtn.addEventListener('click', () => {
        closeModal();
      });
    });

    // Handle confirm buttons (close modal after action)
    document.querySelectorAll('[data-modal-confirm]').forEach(confirmBtn => {
      if (confirmBtn._modalConfirmInitialized) return;
      confirmBtn._modalConfirmInitialized = true;

      confirmBtn.addEventListener('click', () => {
        const overlay = confirmBtn.closest('[data-modal-overlay]');
        if (overlay) {
          overlay.dispatchEvent(new CustomEvent('modal:confirm', { bubbles: true }));
        }
        closeModal();
      });
    });

    // Handle overlay click to close
    document.querySelectorAll('[data-modal-overlay]').forEach(overlay => {
      if (overlay._modalOverlayInitialized) return;
      overlay._modalOverlayInitialized = true;

      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeModal();
        }
      });
    });
  }

  /**
   * Handle keyboard events
   */
  function handleKeydown(e) {
    if (!activeModal) return;

    // Close on Escape
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }

    // Trap focus with Tab
    if (e.key === 'Tab') {
      const modal = activeModal.querySelector('[data-modal]');
      const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModals);
  } else {
    initModals();
  }

  // Add keyboard listener
  document.addEventListener('keydown', handleKeydown);

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initModals);

  // Expose API globally
  window.Modal = {
    open: openModal,
    close: closeModal
  };
})();

